module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "map-score-block map-indicator-block",
    on: {
      "mouseenter": function($event) {
        _vm.handleHover(true)
      },
      "mouseleave": function($event) {
        _vm.handleHover(false)
      }
    }
  }, [_c('color-block', {
    attrs: {
      "score": _vm.indicatorScore,
      "name": _vm.indicator.name,
      "ishovered": _vm.indicator.indicatorHovered
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fcaca814","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/heat-map-graphic/MapIndicator.vue
// module id = 561
// module chunks = 1